import React from 'react'
import About from './Components/Javascript/About'

export default function AboutPage() {
  return (
    <div>
      <About/>
    </div>
  )
}
